import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  getHolidays,
  createHoliday,
  updateHoliday,
  deleteHoliday,
} from '../api/holidays.api';
import { IHoliday, IGetHolidays } from '../models/holidays.model';

interface IHolidayState {
  holidays: IHoliday[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IHolidayState = {
  holidays: [],
  isLoading: false,
};

const holidaySlicer = createSlice({
  name: 'holiday',
  initialState,
  reducers: {
    getHolidaysStart: (state: IHolidayState) => {
      state.holidays = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getHolidaysSuccess: (
      state: IHolidayState,
      action: PayloadAction<IGetHolidays>,
    ) => {
      state.holidays = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getHolidaysFailure: (
      state: IHolidayState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.holidays = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IHolidayState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: IHolidayState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IHolidayState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    updateSuccess: (state: IHolidayState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    deleteSuccess: (state: IHolidayState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const {
  getHolidaysStart,
  getHolidaysSuccess,
  getHolidaysFailure,
  requestStart,
  requestFailure,
  createSuccess,
  updateSuccess,
  deleteSuccess,
} = holidaySlicer.actions;

export default holidaySlicer.reducer;

export const doGetHolidays = (): any => async (dispatch: any) => {
  try {
    dispatch(getHolidaysStart());
    const response = await getHolidays();
    dispatch(getHolidaysSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getHolidaysFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateHoliday =
  (data: IHoliday): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await createHoliday(data);
      dispatch(createSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doUpdateHoliday =
  (id: string, data: IHoliday): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await updateHoliday(id, data);
      dispatch(updateSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doDeleteHoliday =
  (id: string): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await deleteHoliday(id);
      dispatch(updateSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };
